// Global error event bus — ให้ non-React module (เช่น axios interceptor) แจ้ง error
// ไปยัง React component (GlobalErrorDialog) ที่ mount ไว้ที่ root ได้ โดยไม่ต้องผ่าน props/redux

const listeners = new Set();

// กัน dialog เด้งรัว ๆ เวลามีหลาย request fail พร้อมกันด้วยข้อความเดิม (เช่น network hiccup ตอน
// หน้าเดียวยิงหลาย API พร้อมกัน) — ข้อความเดิมภายในช่วงเวลานี้ถือเป็น error เดียวกัน ไม่เปิดซ้ำ
const DEDUPE_WINDOW_MS = 3000;
let lastMessage = null;
let lastReportedAt = 0;

// status = HTTP status code (ถ้ามี) ให้ GlobalErrorDialog โชว่เป็น badge — ไม่มีก็ได้ (เช่น network error
// ที่ไม่มี response เลย)
export const reportGlobalError = (message, status = null) => {
  if (!message) return;
  const now = Date.now();
  if (message === lastMessage && now - lastReportedAt < DEDUPE_WINDOW_MS) {
    return;
  }
  lastMessage = message;
  lastReportedAt = now;
  listeners.forEach((cb) => cb(message, status));
};

export const subscribeGlobalError = (cb) => {
  listeners.add(cb);
  return () => listeners.delete(cb);
};
